exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul.assessments-to-do{padding:0}ul.assessments-to-do li{margin-left:5px;display:inline-block;font-size:22px}ul.assessments-to-do li div{width:100%;display:inline-block}ul.assessments-to-do li div.hidden{display:none}", ""]);

// exports
